import * as ListMeasurementsWidget from './listMeasurements';

import * as Basic from './basic';
import * as Alerts from './alerts';
import * as Inventory from './inventory';
import * as MAV from './mav';
import * as PM from './pm';
import * as SU from './su';

import { isBeta } from '../../api/config';

const widgets = {
    Alerts,
    ListMeasurementsWidget,
    Basic,
    MAV,
    PM,
    SU,
};

// YSo, 16.08.2024: Deactivate inventory only on the production system, do not put the wiget to the report canvas
// also if it presents in the report definition
if (isBeta) {
    (widgets as any).Inventory = Inventory;
}

export function getByName(name: string) {
    const fullName = name.split('.');

    return fullName.reduce((root: any, name: string) => {
        return (root || {})[name];
    }, widgets);
}



// WEBPACK FOOTER //
// ./src/components/widget/index.ts